import React from 'react';
import Loader from './Loader'; // Импортируем компонент Loader

const PaymentScreen = () => {
    return (
        <div className="payment-screen">
            <h1 className="payment-title">Оплатите доступ в приложение</h1>
            <Loader />
        </div>
    );
};

export default PaymentScreen; 